import { createFileRoute } from "@tanstack/react-router";
import { SettingsScreen } from "../../../features/settings/settings-screen";

export const Route = createFileRoute("/_authed/settings/")({
  component: SettingsPage,
});

function SettingsPage() {
  const { client, tenant } = Route.useRouteContext();
  return <SettingsScreen client={client} tenant={tenant} />;
}
